let $starRating = document.querySelectorAll('[data-toggle="rating"]');
if ($starRating.length) {
	let $inputStar = document.getElementById('user_star');

	for (const $starRatingElement of $starRating) {
		$starRatingElement.addEventListener('click', function () {
			let self = this,
				rate = self.dataset.rate;

			self.closest('[data-rating]').setAttribute('data-rating-value', rate);
			$inputStar.value = rate;
		});
	}
}

